import React, {ReactElement, useMemo} from 'react';
import {Typography} from '@customink/pigment-react';
import Skeleton from '@mui/material/Skeleton';
import {formatCurrency} from '../../utils/helpers';

const ZERO = '0.0';

type PriceProps = {
  price: number | string;
  originalPrice?: string;
  className?: string;
  skipFormatting?: boolean;
};
const Price: React.FC<PriceProps> = ({
  price,
  originalPrice,
  className,
  skipFormatting
}: PriceProps): ReactElement => {
  const formattedOriginalPrice = useMemo(() => {
    if (!originalPrice) return null;
    return skipFormatting
      ? originalPrice
      : formatCurrency(Number(originalPrice));
  }, [originalPrice, skipFormatting]);

  const formattedPrice = useMemo(() => {
    if (!price) return null;
    return skipFormatting ? price : formatCurrency(Number(price));
  }, [price, skipFormatting]);

  if (!price) {
    return <Skeleton width={80} height={30} />;
  }
  if (typeof price === 'number' ? price.toString() === ZERO : price === ZERO) {
    return null;
  }
  return (
    <Typography className={className} variant="subHeading">
      {originalPrice ? (
        <>
          <Typography className={`${className}-original`} variant="subHeading">
            {`Originally ${formattedOriginalPrice}`}
          </Typography>
          {`Now ${formattedPrice}`}
        </>
      ) : (
        <>{formattedPrice}</>
      )}
    </Typography>
  );
};

Price.defaultProps = {
  originalPrice: null,
  className: '',
  skipFormatting: false
};

export default Price;
